import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";

function AllPagesSitePublisher({ dataSitePublisher }) {
  const params = useParams();
  const sitePublisherID = params.id;
  const [sitePublisherData, setSitePublisherData] = useState();
  const [pages, setPages] = useState([]);

  const history = useHistory();

  useEffect(() => {
    const initDataComponent = async () => {
      await getSitePublisherData();
      await getAllPageInSitePublisher();
    };
    initDataComponent();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSitePublisherData = async () => {
    setSitePublisherData(
      await sendRequestGetSitePublisherData(sitePublisherID)
    );
  };

  const sendRequestGetSitePublisherData = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let resultSitePublisherData;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      resultSitePublisherData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultSitePublisherData.data.data;
  };

  const getAllPageInSitePublisher = async () => {
    setPages(await sendRequestGetAllPageInSitePublisher());
  };

  const sendRequestGetAllPageInSitePublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let allPageInSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      allPageInSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/page/site-publisher/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return allPageInSitePublisher.data.data;
  };

  const generatePageSitePublisher = (pages) => {
    return pages.map((page, index) => {
      return (
        <tr>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(page.id)}</td>
          <td>
            {page.title}{" "}
            {page.isMultiPage ? (
              <span className="badge badge-danger">چند صفحه ای</span>
            ) : (
              <></>
            )}
          </td>
          <td>
            <a href={page.link} className="btn btn-info w-100" target="_blank">
              <i className="fa fa-eye"></i>
            </a>
          </td>
          <td>
            <Link
              to={`/manage/publishers/alternative/${page.id}/all-positions`}
              className="btn btn-primary w-100"
            >
              <i class="fas fa-ad"></i>
            </Link>
          </td>
        </tr>
      );
    });
  };

  const exportReportExcel = () => {
    let sitePublisherData = { ...dataSitePublisher[sitePublisherID] };
    if (Object.keys(sitePublisherData).length === 0) {
      alert("شما هیچ جایگاه ای انتخاب نکردید.");
      return;
    }

    let sitePublisherUrl = dataSitePublisher[sitePublisherID].url;
    delete sitePublisherData.url;

    var option = {};
    option.fileName = `گزارش صفحات در سایت ${sitePublisherUrl}`;
    let dataExcelFile = [
      { one: sitePublisherUrl, two: getPriceSitePublisher(sitePublisherData) },
    ];
    for (const key in sitePublisherData) {
      const item = sitePublisherData[key];
      dataExcelFile = [
        ...dataExcelFile,
        ...generateArrayReportExportExcel(item),
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
      {
        sheetData: dataExcelFile,
      },
    ];

    const toExcel = new ExportJsonExcel(option); //new
    toExcel.saveExcel();
  };

  const generateArrayReportExportExcel = (sitePublisherData) => {
    return [
      {
        one: sitePublisherData.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(sitePublisherData.price)
        ),
      },
      { ...sitePublisherData.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (sitePublisherData) => {
    let pricePage = 0;
    for (const key in sitePublisherData) {
      pricePage = pricePage + sitePublisherData[key].price;
    }
    return helpersNumbers.toPersianNum(
      helpersNumbers.toFormatFinanceNumber(pricePage)
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  صفحات سایت {"  "}{" "}
                  {sitePublisherData?.url.replace("http://", "")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to={() => {
                    if (params.categoryUserSitePublisherID !== undefined) {
                      return (
                        "/manage/publishers/edit-banner-category-site-publisher-alternative/" +
                        params.categoryUserSitePublisherID
                      );
                    }

                    return "/manage/publishers/add-category-site-publisher-alternative-via-select-positions";
                  }}
                  className="btn btn-success"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              <div className="table-responsive pt-3">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره صفحه</td>
                      <td>عنوان صفحه</td>
                      <td>مشاهده صفحه</td>
                      <td>رزور جایگاه های تبلیغات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {pages.length != 0 ? (
                      generatePageSitePublisher(pages)
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
              <div>
                <span className="pl-2">
                  <Link
                    className="btn btn-danger"
                    to={`/manage/publishers/alternative/${sitePublisherID}/all-independent-positions/`}
                  >
                    <span className="pl-2">
                      <i className="fa fa-eye"></i>
                    </span>
                    <span>نمایش جایگاه های مستقل</span>
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
  };
};

export default connect(mapStateToProps)(AllPagesSitePublisher);
